<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :search="search"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="getColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.company="{ item }">
        {{ item.company ? item.company : item.description }}
      </template>
      <template v-slot:item.level="{ item }">
        <span
          v-if="item.level"
          style="color:blue; font-weight:800"
        >
          是
        </span>
        <span v-else>否</span>
      </template>
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>客户中心</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            solo-inverted
            single-line
            hide-details
            dense
            style="width:150px"
          />
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            style="z-index:60;"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dates"
                clearable
                solo-inverted
                hide-details
                label="时间范围"
                dense
                style="margin-left:10px;width:210px;"
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                @change="selectsw"
                @blur="selectsw"
              />
            </template>
            <v-date-picker
              v-model="dates"
              range
              no-title
              locale="zh-cn"
            />
          </v-menu>
          <v-select
            v-model="uid"
            clearable
            solo-inverted
            hide-details
            :items="items"
            :menu-props="{ top: true, offsetY: true }"
            prepend-inner-icon="mdi-account"
            item-text="name"
            item-value="id"
            label="商务"
            style="margin-left:10px;width:10%;"
            dense
            @change="selectsw"
          />
          <v-select
            v-model="status"
            clearable
            solo-inverted
            hide-details
            :items="statusArr"
            :menu-props="{ top: true, offsetY: true }"
            prepend-inner-icon="mdi-autorenew"
            item-text="label"
            item-value="value"
            label="状态"
            style="margin-left:10px;width:10%;"
            dense
            @change="selectsw"
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="0px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                添加
              </v-btn>
            </template>
            <validation-observer
              ref="observer"
              v-slot="{ invalid }"
            >
              <form @submit.prevent="submit">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-dialog
                          v-model="dialog"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <v-card>
                            <v-toolbar
                              dark
                              color="primary"
                            >
                              <v-btn
                                icon
                                dark
                                @click="dialog = false"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                              <v-spacer />
                              <v-toolbar-items>
                                <v-btn
                                  dark
                                  color="success"
                                  type="submit"
                                  :disabled="invalid"
                                  @click="sava"
                                >
                                  保存
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-divider />
                            <v-card
                              class="mb-12"
                              color="red lighten-5"
                            >
                              <v-row
                                class="light-blue lighten-5 pa-6"
                              >
                                <v-col
                                  cols="24"
                                  md="6"
                                >
                                  <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <validation-provider
                                        v-slot="{ errors }"
                                        name="访问日期"
                                        rules="required"
                                      >
                                        <v-text-field
                                          v-model="editedItem.extension_date"
                                          label="访问日期"
                                          :error-messages="errors"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                        />
                                      </validation-provider>
                                    </template>
                                    <v-date-picker
                                      v-model="editedItem.extension_date"
                                      locale="zh-cn"
                                      @input="menu2 = false"
                                    />
                                  </v-menu>
                                </v-col>
                                <v-col>
                                  <v-text-field
                                    v-model="editedItem.extension_tm"
                                    label="时间"
                                    prepend-icon="mdi-clock-time-four-outline"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="商务负责人"
                                    rules="required"
                                  >
                                    <v-select
                                      v-model="editedItem.user_id"
                                      :items="items"
                                      :menu-props="{ top: true, offsetY: true }"
                                      :error-messages="errors"
                                      item-text="name"
                                      item-value="id"
                                      label="商务负责人"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="概况描述"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-model="editedItem.description"
                                      :error-messages="errors"
                                      label="概况描述"
                                      rows="7"
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <v-alert
                                    outlined
                                  >
                                    填写信息后，点击右上角的【保存】提交
                                  </v-alert>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-card>
                          <!--<v-card>
                            <v-toolbar
                              dark
                              color="primary"
                            >
                              <v-btn
                                icon
                                dark
                                @click="dialog = false"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                              <v-spacer />
                              <v-toolbar-items>
                                <v-btn
                                  dark
                                  color="success"
                                  @click="save"
                                >
                                  Save
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-divider />

                            <v-stepper v-model="e1">
                              <v-stepper-header>
                                <v-stepper-step
                                  :complete="e1 > 1"
                                  step="1"
                                >
                                  基本信息
                                </v-stepper-step>

                                <v-divider />

                                <v-stepper-step
                                  :complete="e1 > 2"
                                  step="2"
                                >
                                  扩展信息
                                </v-stepper-step>

                                <v-divider />

                                <v-stepper-step step="3">
                                  分配
                                </v-stepper-step>
                              </v-stepper-header>

                              <v-stepper-items>
                                <v-stepper-content step="1">
                                  <v-card
                                    class="mb-12"
                                    color="red lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="公司名称"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.company"
                                            :error-messages="errors"
                                            label="公司名称"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户姓名"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.name"
                                            :error-messages="errors"
                                            label="客户姓名"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户电话"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.phone"
                                            :error-messages="errors"
                                            label="客户电话"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="其它联系方式"
                                        >
                                          <v-textarea
                                            v-model="editedItem.other_phone"
                                            :error-messages="errors"
                                            label="其它联系方式"
                                            rows="2"
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="概况描述"
                                        >
                                          <v-textarea
                                            v-model="editedItem.description"
                                            :error-messages="errors"
                                            label="概况描述"
                                            rows="3"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    color="primary"
                                    @click="e1 = 2"
                                  >
                                    下一步
                                  </v-btn>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                  <v-card
                                    class="mb-12"
                                    color="green lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6 white--text"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户来源"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.customer_source"
                                            :error-messages="errors"
                                            label="客户来源"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="线索来源"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.source"
                                            :error-messages="errors"
                                            label="线索来源"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="搜索词"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.search_keyword"
                                            :error-messages="errors"
                                            label="搜索词"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="关键词"
                                        >
                                          <v-text-field
                                            v-model="editedItem.keyword"
                                            :error-messages="errors"
                                            label="关键词"
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户类型"
                                        >
                                          <v-radio-group
                                            v-model="editedItem.type"
                                            :error-messages="errors"
                                            mandatory
                                            row
                                            label="客户类型"
                                          >
                                            <v-radio
                                              label="A类客户"
                                              value="Ａ"
                                            />
                                            <v-radio
                                              label="B类客户"
                                              value="Ｂ"
                                            />
                                            <v-radio
                                              label="C类客户"
                                              value="C"
                                            />
                                          </v-radio-group>
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="结果（状态）"
                                        >
                                          <v-radio-group
                                            v-model="editedItem.status"
                                            :error-messages="errors"
                                            mandatory
                                            row
                                            label="结果（状态）"
                                          >
                                            <v-radio
                                              label="线索"
                                              value="0"
                                            />
                                            <v-radio
                                              label="待定"
                                              value="1"
                                            />
                                            <v-radio
                                              label="无效"
                                              value="2"
                                            />
                                            <v-radio
                                              label="有效约见"
                                              value="3"
                                            />
                                            <v-radio
                                              label="报价后高意愿"
                                              value="4"
                                            />
                                            <v-radio
                                              label="报价后低意愿"
                                              value="5"
                                            />
                                            <v-radio
                                              label="签约"
                                              value="6"
                                            />
                                            <v-radio
                                              label="输单"
                                              value="7"
                                            />
                                          </v-radio-group>
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="无效原因"
                                        >
                                          <v-textarea
                                            v-model="editedItem.remarks"
                                            :error-messages="errors"
                                            label="无效原因"
                                            rows="2"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    class="ma-2"
                                    @click="e1 = 1"
                                  >
                                    上一步
                                  </v-btn>
                                  <v-btn
                                    class="ma-2"
                                    color="primary"
                                    @click="e1 = 3"
                                  >
                                    下一步
                                  </v-btn>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                  <v-card
                                    class="mb-12"
                                    color="blue lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6 white--text"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="商务负责人"
                                          rules="required"
                                        >
                                          <v-select
                                            v-model="editedItem.user_id"
                                            :items="items"
                                            :menu-props="{ top: true, offsetY: true }"
                                            :error-messages="errors"
                                            item-text="name"
                                            item-value="id"
                                            label="商务负责人"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="生命周期日志"
                                        >
                                          <v-textarea
                                            v-model="editedItem.life_cycle"
                                            :error-messages="errors"
                                            label="生命周期日志"
                                            hint="从分配任务到签单过程中的事件记录到生命周期中，换行分割"
                                            rows="7"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    class="ma-2"
                                    @click="e1 = 2"
                                  >
                                    上一步
                                  </v-btn>
                                </v-stepper-content>
                              </v-stepper-items>
                            </v-stepper>
                          </v-card>-->
                        </v-dialog>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </form>
            </validation-observer>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="300px"
          >
            <v-card>
              <v-card-title
                class="headline"
              >
                请确认是否删除?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  确定
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template
        v-slot:item.actions="{ item }"
      >
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <!--<v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />-->
    </div>
    <!--完善信息开始-->
    <v-dialog
      v-model="dialogEdit"
      fullscreen
      hide-overlay
      transition="dialogEdit-bottom-transition"
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="submit">
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialogEdit = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>客户详情</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-btn
                  color="success"
                  type="submit"
                  :disabled="invalid"
                  @click="save_full"
                >
                  Save
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list
              three-line
              subheader
            >
              <v-subheader>客户信息</v-subheader>
              <v-row
                class="spacing-playground pa-3"
              >
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <validation-provider
                        v-slot="{ errors }"
                        name="访问日期"
                        rules="required"
                      >
                        <v-text-field
                          v-model="editedItem.extension_date"
                          label="访问日期"
                          :error-messages="errors"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </validation-provider>
                    </template>
                    <v-date-picker
                      v-model="editedItem.extension_date"
                      locale="zh-cn"
                      @input="menu2 = false"
                    />
                  </v-menu>
                </v-col>
                <v-spacer />
                <v-col
                  cols="24"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="访问时间"
                    rules="required"
                  >
                    <v-text-field
                      v-model="editedItem.extension_time"
                      :error-messages="errors"
                      label="访问时间"
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="渠道来源"
                    rules="required"
                  >
                    <v-select
                      v-model="editedItem.source"
                      :items="channel_sourceArr"
                      :menu-props="{ top: true, offsetY: true }"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      label="渠道来源"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="客户来源"
                    rules="required"
                  >
                    <v-select
                      v-model="editedItem.customer_source"
                      :items="customer_sourceArr"
                      :menu-props="{ top: true, offsetY: true }"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      label="客户来源"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.search_keyword"
                    label="搜索词"
                  />
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.keyword"
                    label="关键词"
                  />
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.page"
                    label="初始页面"
                  />
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-select
                    v-model="editedItem.terminal"
                    :items="terminalArr"
                    :menu-props="{ top: true, offsetY: true }"
                    item-text="name"
                    item-value="id"
                    label="终端"
                    required
                  />
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.ip"
                    label="终端IP"
                  />
                </v-col>
                <v-col
                  cols="24"
                  md="6"
                >
                  <v-radio-group
                    v-model="editedItem.is_clue"
                    mandatory
                    row
                    label="有无线索"
                  >
                    <v-radio
                      v-for="(item, i) in is_clueArr"
                      :key="i"
                      :label="item.name"
                      :value="item.id"
                    />
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="商务负责人"
                    rules="required"
                  >
                    <v-select
                      v-model="editedItem.user_id"
                      :items="items"
                      :menu-props="{ top: true, offsetY: true }"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      label="商务负责人"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="24"
                  md="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="概况描述"
                    rules="required"
                  >
                    <v-textarea
                      v-model="editedItem.description"
                      :error-messages="errors"
                      label="概况描述"
                      rows="3"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-list>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
    <!--完善信息结束-->
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  extend('required', {
    ...required,
    message: '{_field_} 不能为空',
  })

  export default {
    name: 'CustomerView',
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data: () => ({
      menu2: false,
      e1: 1,
      radios: 1,
      search: '',
      dialog: false,
      notifications: false,
      dialogEdit: false,
      sound: true,
      widgets: false,
      dialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      roleList: [],
      headers: [
        {
          text: '客户编号',
          align: 'center',
          value: 'no',
          width: '150',
        },
        { text: '时间', value: 'extension_date', width: '120' },
        { text: '分配AE', value: 'auther', width: '120' },
        { text: '公司名称/概况', value: 'company', sortable: false, width: '200' },
        { text: '客户来源', value: 'customer_source_name', width: '120' },
        { text: '线索来源', value: 'source_name', width: '120' },
        // { text: '联系人', value: 'name', sortable: false, width: '100' },
        // { text: '电话', value: 'phone', sortable: false, width: '120' },
        // { text: '其他联系方式', value: 'other_phone', width: '160' },
        // { text: '公司名称', value: 'company', sortable: false, width: '150' },
        { text: '搜索词', value: 'search_keyword', width: '120' },
        { text: '关键词', value: 'keyword', width: '120' },
        { text: '高价值', value: 'level', width: '120' },
        { text: '结果', value: 'status', width: '100' },
        { text: '无效原因', value: 'invalid_name', width: '300' },
        // { text: '初步判断', value: 'type', width: '120' },
        // { text: '无效原因', value: 'remarks', sortable: false, width: '150' },
        { text: '操作', value: 'actions', sortable: false, width: '100' },
      ],
      desserts: [],
      editedIndex: -1,
      roles: '',
      items: [],
      uid: '',
      status: '',
      statusArr: [
        {
          value: 29,
          label: '客户池',
        },
        {
          value: 30,
          label: '待定',
        },
        {
          value: 51,
          label: '高价值待定',
        },
        {
          value: 31,
          label: '有效约见',
        },
        {
          value: 32,
          label: '报价后高意愿',
        },
        {
          value: 33,
          label: '报价后低意愿',
        },
        {
          value: 36,
          label: '签约',
        },
        {
          value: 34,
          label: '谎称要签',
        },
        {
          value: 35,
          label: '输单',
        },
        {
          value: 37,
          label: '无效',
        },
      ],
      dates: [],
      menu1: false,
      channel_sourceArr: [],
      customer_sourceArr: [],
      terminalArr: [],
      is_clueArr: [{ id: 1, name: '有' }, { id: 0, name: '无' }],
      editedItem: {
        extension_date: new Date().toISOString().substr(0, 10),
        extension_time: '',
        extension_tm: new Date().toLocaleTimeString('chinese', { hour12: false }).substr(0, 8),
        description: '',
        customer_source: '',
        source: '',
        search_keyword: '',
        keyword: '',
        type: '',
        page: '',
        ip: '',
        terminal: 26,
        is_clue: 1,
        remarks: '',
        auther: '',
      },
      defaultItem: {
        description: '',
        status: 29,
        remarks: '',
        auther: '',
      },
      classifyArr: [],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '录入客户信息' : '修改客户信息'
      },
    },

    watch: {
      dialog (val) {
        if (val === true) {
          if (this.editedIndex === -1) {
            // this.roles = 'sale'
          }
        }
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取销售列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/admins')
          .then(response => {
            if (response.status === 200) {
              this.items = response.data.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取lib
        axios
          .get(process.env.VUE_APP_BASE_API + '/classify/all')
          .then(response => {
            if (response.data.code === 20000) {
              this.classifyArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // get Customer
        this.customer()
      },

      customer () {
        axios
          .post(process.env.VUE_APP_BASE_API + '/customer/list', { userId: this.uid, dates: this.dates, status: this.status })
          .then(response => {
            if (response.status === 200) {
              this.desserts = response.data.data.data
              this.desserts.map((item, i, arr) => {
                switch (item.status) {
                  case 29:
                    item.status = '客户池'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 51:
                    item.status = '高价值待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '报价后高意愿'
                    break
                  case 33:
                    item.status = '报价后低意愿'
                    break
                  case 36:
                    item.status = '签约'
                    break
                  case 34:
                    item.status = '谎称要签'
                    break
                  case 35:
                    item.status = '输单'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.customer_source_name = this.classifyArr[item.customer_source]
                item.source_name = this.classifyArr[item.source]
                const invalid = item.invalid_tip !== null ? '(' + item.invalid_tip + ')' : ''
                const iname = this.classifyArr[item.invalid_status] + invalid
                item.invalid_name = iname !== 'undefined' ? iname : ''
              })
              // console.log(this.desserts)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      selectsw () {
        this.customer()
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.extension_date = (this.editedItem.extension_date !== null) ? this.editedItem.extension_date : new Date().toISOString().substr(0, 10)
        this.editedItem.extension_time = (this.editedItem.extension_time !== null) ? this.editedItem.extension_time : ''
        this.editedItem.terminal = (this.editedItem.terminal !== null) ? this.editedItem.terminal : 26
        // this.editedItem.status = (this.editedItem.status !== null) ? this.editedItem.status : 29
        this.editedItem.is_clue = (this.editedItem.is_clue !== null) ? this.editedItem.is_clue : 1
        switch (item.status) {
          case '客户池':
            this.editedItem.status = 29
            break
          case '待定':
            this.editedItem.status = 30
            break
          case '高价值待定':
            this.editedItem.status = 51
            break
          case '有效约见':
            this.editedItem.status = 31
            break
          case '报价后高意愿':
            this.editedItem.status = 32
            break
          case '报价后低意愿':
            this.editedItem.status = 33
            break
          case '签约':
            this.editedItem.status = 36
            break
          case '谎称要签':
            this.editedItem.status = 34
            break
          case '输单':
            this.editedItem.status = 35
            break
          case '无效':
            this.editedItem.status = 37
            break
        }
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/2')
          .then(response => {
            if (response.data.code === 20000) {
              this.channel_sourceArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/3')
          .then(response => {
            if (response.data.code === 20000) {
              this.customer_sourceArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/4')
          .then(response => {
            if (response.data.code === 20000) {
              this.terminalArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.dialogEdit = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/customer/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              // this.desserts.splice(this.editedIndex, 1)
              this.initialize()
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },

      submit () {

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save_full () {
        const item = this.editedItem
        const url = process.env.VUE_APP_BASE_API + '/customer/update/' + item.id
        axios
          .post(url, this.editedItem)
          .then(response => {
            if (response.data.code === 20000) {
              this.$message.success('提交成功')
              this.initialize()
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.dialogEdit = false
      },

      sava () {
        this.$refs.observer.validate()
        if (this.editedItem.description !== '' && this.editedItem.user_id !== '') {
          const item = this.editedItem
          const _editedIndex = this.editedIndex
          const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/customer/create' : process.env.VUE_APP_BASE_API + '/customer/update/' + item.id
          this.editedItem.roles = this.roles
          axios
            .post(url, this.editedItem)
            .then(response => {
              if (response.data.code === 20000) {
                switch (item.status) {
                  case 29:
                    item.status = '客户池'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 51:
                    item.status = '高价值待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '报价后高意愿'
                    break
                  case 33:
                    item.status = '报价后低意愿'
                    break
                  case 36:
                    item.status = '签约'
                    break
                  case 34:
                    item.status = '谎称要签'
                    break
                  case 35:
                    item.status = '输单'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.id = response.data.id
                item.auther = response.data.auther
                item.no = response.data.no
                if (_editedIndex > -1) {
                  Object.assign(this.desserts[_editedIndex], item)
                } else {
                  this.desserts.push(item)
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
          this.close()
        }
      },

      getColor (calories) {
        let color = 'green'
        switch (calories) {
          case '客户池':
            color = 'info'
            break
          case '待定':
            color = '#FD9A13'
            break
          case '高价值待定':
            color = 'rgb(16 175 74 / 63%)'
            break
          case '有效约见':
            color = 'teal'
            break
          case '报价后高意愿':
            color = 'blue'
            break
          case '报价后低意愿':
            color = 'lime'
            break
          case '签约':
            color = 'green'
            break
          case '谎称要签':
            color = 'brown'
            break
          case '输单':
            color = 'blue-grey'
            break
          case '无效':
            color = 'grey'
            break
        }
        return color
      },

    },
  }
</script>
